export default "__VITE_ASSET__daeeb360__"